var _circle, _circle2, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddDietBig = function SvgAddDietBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 136,
    viewBox: "0 0 125 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.194,
    cy: 76.8698,
    r: 58.3073,
    fill: "#EFF4F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8073,
    cy: 69.7761,
    r: 57.9134,
    stroke: "#DCE5E1",
    strokeWidth: 0.787937
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.08 78.4606H100.473C98.053 62.4678 84.7884 50.0558 68.413 48.9307C68.638 48.5271 68.7662 48.0616 68.7662 47.5656C68.7662 46.0286 67.5195 44.7684 65.9769 44.7684C64.4371 44.7684 63.1798 46.0258 63.1798 47.5656C63.1798 48.0617 63.308 48.5274 63.5342 48.9312C47.1618 50.0592 33.8931 62.4697 31.4809 78.4606H29.8658C29.2395 78.4606 28.6729 78.7153 28.2661 79.13C27.8502 79.538 27.5965 80.1128 27.5965 80.7299C27.5965 81.9842 28.6157 83.007 29.8658 83.007H102.08C102.698 83.007 103.274 82.7523 103.682 82.3351C104.093 81.9236 104.349 81.359 104.349 80.7299C104.349 79.4816 103.328 78.4606 102.08 78.4606ZM49.2985 60.4073C45.7432 65.1141 42.4954 71.2785 41.5119 78.4606H37.3493C39.0869 67.3462 46.163 58.2854 55.5153 53.6827C53.5837 55.3757 51.3831 57.6477 49.2985 60.4073Z",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.526 51.4102C55.0821 54.0419 43.7909 64.5057 42.0338 79.051H36.668C38.4723 65.7821 47.7306 55.2789 59.526 51.4102Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 109.689,
    y1: 0.5,
    x2: 109.689,
    y2: 13.107,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 103.199,
    y1: 6.86163,
    x2: 115.806,
    y2: 6.86163,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81.42,
    y1: 17.7031,
    x2: 81.42,
    y2: 24.219,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 78.0664,
    y1: 20.9941,
    x2: 84.5823,
    y2: 20.9941,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10.3926,
    y1: 52.7109,
    x2: 10.3926,
    y2: 59.2268,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.03906,
    y1: 56.0019,
    x2: 13.5549,
    y2: 56.0019,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.913,
    y: 42.1267,
    width: 51.6099,
    height: 18.5165,
    rx: 2.95476,
    transform: "rotate(-25.1706 69.913 42.1267)",
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6367,
    y: 44.2148,
    width: 9.45524,
    height: 9.45524,
    rx: 1.57587,
    transform: "rotate(-25.1706 75.6367 44.2148)",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.1992,
    y: 38.7969,
    width: 26.7898,
    height: 3.15175,
    rx: 0.787937,
    transform: "rotate(-25.1706 88.1992 38.7969)",
    fill: "#E5E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5117,
    y: 43.7109,
    width: 17.3346,
    height: 3.15175,
    rx: 0.787937,
    transform: "rotate(-25.1706 90.5117 43.7109)",
    fill: "#E5E5E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3581,
    y: 58.6265,
    width: 40.7331,
    height: 14.6142,
    rx: 2.33205,
    transform: "rotate(18.8809 20.3581 58.6265)",
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 0.93282
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4609,
    y: 62.9531,
    width: 7.46256,
    height: 7.46256,
    rx: 1.24376,
    transform: "rotate(18.8809 22.4609 62.9531)",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 0.93282
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5586,
    y: 66.7773,
    width: 21.1439,
    height: 2.48752,
    rx: 0.62188,
    transform: "rotate(18.8809 32.5586 66.7773)",
    fill: "#E5E5E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1719,
    y: 70.832,
    width: 13.6814,
    height: 2.48752,
    rx: 0.62188,
    transform: "rotate(18.8809 31.1719 70.832)",
    fill: "#E5E5E5"
  })));
};
export default SvgAddDietBig;